import { render, staticRenderFns } from "./connection-error.vue?vue&type=template&id=955ce2ec&scoped=true&"
import script from "./connection-error.vue?vue&type=script&lang=js&"
export * from "./connection-error.vue?vue&type=script&lang=js&"
import style0 from "./connection-error.vue?vue&type=style&index=0&id=955ce2ec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955ce2ec",
  null
  
)

export default component.exports